<template>
  <base-wrapper class="portal-layout">
    <div class="section">
      <base-panel class="mb-3">
        <base-search />
      </base-panel>
      <slot name="header"></slot>
      <div class="section__body">
        <slot></slot>
      </div>
    </div>
  </base-wrapper>
</template>

<script setup lang="ts">
import BaseSearch from '@/components/library/searchbars/BaseSearch.vue';
</script>

<style lang="postcss" scoped>
.portal-layout {
  @apply flex;
}

.section {
  @apply flex flex-col grow overflow-y-auto w-screen;

  &__body {
    @apply flex gap-4 grow;
  }

  &::-webkit-scrollbar {
    @apply hidden;
  }
}

/* w-[17.5rem] */
.search-menu-container {
  @apply pl-3 relative h-[calc(100vh-5rem)] basis-[355rem] right-0;
}
</style>
